var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-panel"},[_c('welcome-top-navbar'),_c('main-content'),_c('welcome-content-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }